// Photos réelles des communes (Wikimedia Commons)
export const CITY_PHOTOS = {
 "saint-malo": {
  "src": "/villes/saint-malo.jpg?v=3",
  "author": "Carsten Steger",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Aerial_image_of_Saint-Malo_(view_from_the_south).jpg"
 },
 "dinard": {
  "src": "/villes/dinard.jpg?v=3",
  "author": "https://flickr.com/people/59067924@N00/",
  "license": "CC BY 2.0",
  "page": "https://commons.wikimedia.org/wiki/File:Dinard_Plage_de_l%27Ecluse-2007-08-08.jpg"
 },
 "saint-lunaire": {
  "src": "/villes/saint-lunaire.jpg?v=3",
  "author": "WikiJuL",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Lunaire-Grand_H%C3%B4tel-retouched-by-Rundvald.jpg"
 },
 "saint-briac-sur-mer": {
  "src": "/villes/saint-briac-sur-mer.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Briac-sur-Mer-plaisance-by-Rundvald.JPG"
 },
 "saint-coulomb": {
  "src": "/villes/saint-coulomb.jpg?v=3",
  "author": "Pymouss44",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Coulomb_mairie.JPG"
 },
 "pleurtuit": {
  "src": "/villes/pleurtuit.jpg?v=3",
  "author": "Ppleurtuit",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Bords_de_rance_Pleurtuit_-_Bretagne.jpg"
 },
 "lancieux": {
  "src": "/villes/lancieux.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Lancieux-Mairie-22-BZH-cropped-byRundvald.jpg"
 },
 "saint-jacut-de-la-mer": {
  "src": "/villes/saint-jacut-de-la-mer.jpg?v=3",
  "author": "Aarthur Launay",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint_Jacut_de_la_Mer.JPG"
 },
 "ploubalay": {
  "src": "/villes/beaussais-sur-mer.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Beaussais-sur-Mer-Ploubalay-Mairie-byRundvald.jpg"
 },
 "beaussais-sur-mer": {
  "src": "/villes/beaussais-sur-mer.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Beaussais-sur-Mer-Ploubalay-Mairie-byRundvald.jpg"
 },
 "tremereuc": {
  "src": "/villes/tremereuc.jpg?v=3",
  "author": "Pymouss",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Tr%C3%A9m%C3%A9reuc_-_Mairie.jpg"
 },
 "crehen": {
  "src": "/villes/crehen.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Eglise-Saint-Pierre-Crehen-22-Ouest-Nord-byRundvald.jpg"
 },
 "saint-cast-le-guildo": {
  "src": "/villes/saint-cast-le-guildo.jpg?v=3",
  "author": "Cyril5C",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Cast-le-Guildo_-_La_grande_plage_II.jpg"
 },
 "cancale": {
  "src": "/villes/cancale.jpg?v=3",
  "author": "Arnaud 25",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Cancale_03.jpg"
 },
 "saint-meloir-des-ondes": {
  "src": "/villes/saint-meloir-des-ondes.jpg?v=3",
  "author": "Renhour48",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-M%C3%A9loir-des-Ondes_-_La_mairie.jpg"
 },
 "saint-benoit-des-ondes": {
  "src": "/villes/saint-benoit-des-ondes.jpg?v=3",
  "author": "Renhour48",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Beno%C3%AEt-des-Ondes_-_La_mairie.jpg"
 },
 "hirel": {
  "src": "/villes/hirel.jpg?v=3",
  "author": "Thérèse Gaigé",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Vue_du_bord_de_mer_%C3%A0_Hirel_(35)_-_01.jpg"
 },
 "le-vivier-sur-mer": {
  "src": "/villes/le-vivier-sur-mer.jpg?v=3",
  "author": "Jordiferrer",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Le_Vivier-sur-Mer_(low_tide).JPG"
 },
 "cherrueix": {
  "src": "/villes/cherrueix.jpg?v=3",
  "author": "Espirat",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Cherrueix._Chapelle_sainte_Anne._(3)._2015-04-08.JPG"
 },
 "la-fresnais": {
  "src": "/villes/la-fresnais.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:La_Fresnais_(35)_%C3%89glise_Saint-M%C3%A9en_et_Sainte-Croix_-_Ext%C3%A9rieur_-_05.jpg"
 },
 "saint-broladre": {
  "src": "/villes/saint-broladre.jpg?v=3",
  "author": "(:Julien:)",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:%C3%89glise_de_Saint-Broladre.jpg"
 },
 "roz-sur-couesnon": {
  "src": "/villes/roz-sur-couesnon.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Roz-sur-Couesnon_(35)_Mairie_03.JPG"
 },
 "sains": {
  "src": "/villes/sains.jpg?v=3",
  "author": "Annick Bregain",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Sains_(en_Ille_et_Vilaine)_lumineux_sous_un_ciel_sombre.jpg"
 },
 "saint-georges-de-grehaigne": {
  "src": "/villes/saint-georges-de-grehaigne.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Georges-de-Gr%C3%A9haigne_(35)_%C3%89glise_Ext%C3%A9rieur_20.jpg"
 },
 "saint-marcan": {
  "src": "/villes/saint-marcan.jpg?v=3",
  "author": "Erixsen",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Tour_Chappe_-_Saint_Marcan_-_Ille-et-Vilaine_-_France.jpg"
 },
 "pleine-fougeres": {
  "src": "/villes/pleine-fougeres.jpg?v=3",
  "author": "Annick Bregain",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Pleine-Foug%C3%A8res_en_Ille_et_Vilaine.jpg"
 },
 "pontorson": {
  "src": "/villes/pontorson.jpg?v=3",
  "author": "",
  "license": "CC BY-SA 2.5",
  "page": "https://commons.wikimedia.org/wiki/File:Pontorson_MontStMichel.jpg"
 },
 "beauvoir": {
  "src": "/villes/beauvoir.jpg?v=3",
  "author": "Chatsam",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Vue_du_mont_st_michel_depuis_Beauvoir_(Manche).jpg"
 },
 "le-mont-saint-michel": {
  "src": "/villes/le-mont-saint-michel.jpg?v=3",
  "author": "Lynx1211",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Mont_St_Michel_in_the_afternoon.jpg"
 },
 "mont-dol": {
  "src": "/villes/mont-dol.jpg?v=3",
  "author": "Renhour48",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Mont-Dol_-_La_mairie.jpg"
 },
 "dol-de-bretagne": {
  "src": "/villes/dol-de-bretagne.jpg?v=5",
  "author": "iStock",
  "license": "",
  "page": ""
 },
 "baguer-morvan": {
  "src": "/villes/baguer-morvan.jpg?v=3",
  "author": "GO69",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Baguer-Morvan_(35)_%C3%89glise_1.jpg"
 },
 "baguer-pican": {
  "src": "/villes/baguer-pican.jpg?v=3",
  "author": "Abujoy",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Baguer-Pican.JPG"
 },
 "roz-landrieux": {
  "src": "/villes/roz-landrieux.jpg?v=3",
  "author": "Elmore",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Rozlandrieux1.jpg"
 },
 "lillemer": {
  "src": "/villes/lillemer.jpg?v=3",
  "author": "René Hourdry",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Lillemer_-_La_rue_de_l%27%C3%A9glise.jpg"
 },
 "saint-guinoux": {
  "src": "/villes/saint-guinoux.jpg?v=3",
  "author": "GO69",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Guinoux_(35)_%C3%89glise.jpg"
 },
 "chateauneuf-d-ille-et-vilaine": {
  "src": "/villes/chateauneuf-d-ille-et-vilaine.jpg?v=3",
  "author": "Renhour48",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Ch%C3%A2teauneuf-d%27Ille-et-Vilaine_-_La_mairie.jpg"
 },
 "la-gouesniere": {
  "src": "/villes/la-gouesniere.jpg?v=3",
  "author": "GO69",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:La_Gouesni%C3%A8re_(35)_%C3%89glise_01.jpg"
 },
 "saint-pere-marc-en-poulet": {
  "src": "/villes/saint-pere-marc-en-poulet.jpg?v=3",
  "author": "René Hourdry",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-P%C3%A8re-Marc-en-Poulet_-_Mairie.jpg"
 },
 "miniac-morvan": {
  "src": "/villes/miniac-morvan.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Miniac-Morvan_(35)_%C3%89glise_02.JPG"
 },
 "plerguer": {
  "src": "/villes/plerguer.jpg?v=3",
  "author": "GO69",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Plerguer_(35)_%C3%89glise_01.jpg"
 },
 "le-tronchet": {
  "src": "/villes/le-tronchet.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Le_Tronchet_(35)_Abbaye_-_01.jpg"
 },
 "carfantain": {
  "src": "/villes/carfantain.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Dol-de-Bretagne_(35)_%C3%89glise_Notre-Dame-de-l%27Assomption_de_Carfantin_02.jpg"
 },
 "saint-jouan-des-guerets": {
  "src": "/villes/saint-jouan-des-guerets.jpg?v=3",
  "author": "Pymouss",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Jouan-des-Gu%C3%A9rets_-_%C3%8Ele_Chevret.jpg"
 },
 "saint-suliac": {
  "src": "/villes/saint-suliac.jpg?v=3",
  "author": "Ewan ar Born",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Vue_gr%C3%A8ve_saint_suliac.JPG"
 },
 "la-ville-es-nonais": {
  "src": "/villes/la-ville-es-nonais.jpg?v=3",
  "author": "Pymouss",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:La_Ville-%C3%A8s-Nonais_-_%C3%89glise_02.JPG"
 },
 "la-richardais": {
  "src": "/villes/la-richardais.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:La-Richardais-Mairie-mai2026-byRundvald.jpg"
 },
 "le-minihic-sur-rance": {
  "src": "/villes/le-minihic-sur-rance.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Le-Minihic-sur-Rance-Biblioth%C3%A8que-Municipale-byRunvald.jpg"
 },
 "langrolay-sur-rance": {
  "src": "/villes/langrolay-sur-rance.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Eglise-Saint-Laurent-Langrolay-sur-Rance-byRundvald.jpg"
 },
 "plouer-sur-rance": {
  "src": "/villes/plouer-sur-rance.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Plouer-sur-Rance-Marina-estuaire-de-la-Rance.jpg"
 },
 "pleudihen-sur-rance": {
  "src": "/villes/pleudihen-sur-rance.jpg?v=3",
  "author": "Vandomvan",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:La_cale_de_Mordreuc.jpg"
 },
 "pleslin-trigavou": {
  "src": "/villes/pleslin-trigavou.jpg?v=3",
  "author": "Annick Bregain",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Eglise_et_lavoir_de_Pleslin.jpg"
 },
 "la-vicomte-sur-rance": {
  "src": "/villes/la-vicomte-sur-rance.jpg?v=3",
  "author": "Raydou",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Rancevicomte.jpg"
 },
 "saint-helen": {
  "src": "/villes/saint-helen.jpg?v=3",
  "author": "Raydou",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Les_vestiges_du_ch%C3%A2teau_de_Co%C3%ABtquen.jpg"
 },
 "lanvallay": {
  "src": "/villes/lanvallay.jpg?v=3",
  "author": "Florian Pépellin",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Lanvallay-Dinan_(22).jpg"
 },
 "dinan": {
  "src": "/villes/dinan.jpg?v=4",
  "author": "iStock",
  "license": "",
  "page": ""
 },
 "taden": {
  "src": "/villes/taden.jpg?v=3",
  "author": "Raydou",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Taden_._Le_manoir_de_la_Grand%27Cour.jpg"
 },
 "quevert": {
  "src": "/villes/quevert.jpg?v=3",
  "author": "Lapetitedidi",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Qu%C3%A9vert_Bourg_(13).JPG"
 },
 "saint-samson-sur-rance": {
  "src": "/villes/saint-samson-sur-rance.jpg?v=3",
  "author": "Pymouss",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Saint-Samson-sur-Rance_-_mairie.JPG"
 },
 "corseul": {
  "src": "/villes/corseul.jpg?v=3",
  "author": "Rundvald",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Corseul-Mairie-by-Rundvald.JPG"
 },
 "combourg": {
  "src": "/villes/combourg.jpg?v=3",
  "author": "Targut",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Combourg.jpg"
 },
 "meillac": {
  "src": "/villes/meillac.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Meillac_(35)_%C3%89glise_Saint-Martin_-_Ext%C3%A9rieur_-_02.jpg"
 },
 "lourmais": {
  "src": "/villes/lourmais.jpg?v=3",
  "author": "GO69",
  "license": "CC BY 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:Lourmais_(35)_Place_de_l%27%C3%89glise.jpg"
 },
 "bonnemain": {
  "src": "/villes/bonnemain.jpg?v=3",
  "author": "GO69",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Bonnemain_(35)_Mairie.jpg"
 },
 "cuguen": {
  "src": "/villes/cuguen.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Cuguen_(35)_La_Pierre-Longue_02.JPG"
 },
 "broualan": {
  "src": "/villes/broualan.jpg?v=3",
  "author": "GO69",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:Broualan_(35)_%C3%89glise_9.jpg"
 },
 "la-boussac": {
  "src": "/villes/la-boussac.jpg?v=3",
  "author": "GO69",
  "license": "CC BY-SA 4.0",
  "page": "https://commons.wikimedia.org/wiki/File:La_Boussac_(35)_%C3%89glise_Saint-Pierre_-_Ext%C3%A9rieur_-_01.jpg"
 },
 "trans-la-foret": {
  "src": "/villes/trans-la-foret.jpg?v=3",
  "author": "Pymouss",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Trans-la-For%C3%AAt_-_mairie.jpg"
 },
 "mesnil-roc-h": {
  "src": "/villes/mesnil-roc-h.jpg?v=3",
  "author": "Arnaud LEMÉE",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Mairie_Saint-Pierre-de-Plesguen_1.jpg"
 },
 "pleugueneuc": {
  "src": "/villes/pleugueneuc.jpg?v=3",
  "author": "Abujoy",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Chateau_de_la_Bourbansais.jpg"
 },
 "epiniac": {
  "src": "/villes/epiniac.jpg?v=3",
  "author": "GO69",
  "license": "CC0",
  "page": "https://commons.wikimedia.org/wiki/File:%C3%89piniac_(35)_Mairie_01.jpg"
 },
 "plancoet": {
  "src": "/villes/plancoet.jpg?v=3",
  "author": "Pymouss",
  "license": "CC BY-SA 3.0",
  "page": "https://commons.wikimedia.org/wiki/File:Planco%C3%ABt_-_Mairie.jpg"
 }
};
